import { useTranslation } from 'react-i18next'
import { PortfolioIcon } from '@/components/ui/PortfolioIcon'

export const Services = () => {
  const { t } = useTranslation()
  const items = t('portfolio.consulting.items', { returnObjects: true }) as {
    title: string
    description: string
  }[]
  const markets = t('portfolio.consulting.markets', {
    returnObjects: true,
  }) as { label: string; title: string; description: string }[]
  const icons = ['cube', 'chip', 'cloud', 'tool'] as const
  return (
    <section id="services" className="consulting-section section-pad">
      <div className="shell">
        <div className="consulting-grid">
          <div className="section-copy">
            <p className="eyebrow">{t('portfolio.consulting.eyebrow')}</p>
            <h2>
              {t('portfolio.consulting.title')}
              <span>{t('portfolio.consulting.accent')}</span>
            </h2>
            <p>{t('portfolio.consulting.description')}</p>
            <a className="button secondary" href="#contact">
              {t('portfolio.consulting.cta')}
              <PortfolioIcon name="arrow" />
            </a>
          </div>
          <div className="service-grid">
            {items.map((item, i) => (
              <article key={item.title}>
                <PortfolioIcon name={icons[i] ?? 'chip'} />
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
        <div className="market-grid">
          {markets.map((market) => (
            <article key={market.label}>
              <p className="eyebrow">{market.label}</p>
              <h3>{market.title}</h3>
              <p>{market.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
